<template>
  <b-modal
      ref="end-kanban-be-modal"
      hide-footer
      title="Edition de votre carte Kanban BE"
  >
    <div class="d-block text-center">
      <b-container fluid>
        <br>
        <b-row>
          <b-col sm="6">
            <label>Durée réalisée (heures)</label>
          </b-col>
          <b-col sm="3">
            <b-form-input type="number" step="0.05" min="0" v-model="form.done_workload_hour"></b-form-input>
          </b-col>
        </b-row>
        <br>
        <br>
        <b-row>
          <b-col sm="6">
            <label>Durée réalisée (jours)</label>
          </b-col>
          <b-col sm="3">
            <b-form-input type="number" step="0.05" min="0" v-model="form.done_workload" required></b-form-input>
          </b-col>
        </b-row>
        <br>
        <b-row>
          <b-col sm="6">
            <label>Réalisé par</label>
          </b-col>
          <b-col sm="6">
            <b-form-input type="text" v-model="form.internal_supplier"></b-form-input>
          </b-col>
        </b-row>
        <br>
        <b-row>
          <b-col sm="6">
            <label>Réalisé le</label>
          </b-col>
          <b-col sm="6">
            <b-form-input
                v-model="form.proceed_at"
                type="date"
            ></b-form-input>
          </b-col>
        </b-row>
        <br>
        <hr>
        <b-row>
          <b-col sm="2" style="margin:auto">
            <div v-show="loading" class="text-center">
              <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
            </div>
          </b-col>
          <b-col sm="5">
            <b-button
              class="mt-3"
              variant="outline-info"
              block
              :disabled="!(form.internal_supplier && form.proceed_at)"
              @click="savedModification"
            >
              Enregistrer
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </b-modal>
</template>

<script>
import server from '../../api/server.vue'

export default {
  name: 'EndKanbanBeModal',
  data() {
    const now = new Date()
    const today = now.getFullYear()+'-'+(now.getMonth()+1)+'-'+now.getDate()
    return {
      kanban: null,
      loading: false,
      form:{
        done_workload_hour: 0,
        done_workload: 0,
        proceed_at: today,
        internal_supplier: ''
      }
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    hideModal () {
      this.$refs['end-kanban-be-modal'].hide()
    },
    showModal (kanban) {
      this.kanban = kanban
      this.form.internal_supplier =  this.kanban.internal_supplier
      this.$refs['end-kanban-be-modal'].show()
    },
    savedModification () {
      this.loading = true
      server.editKanbanBe(this.kanban.card_number, this.form).then(res => {
        this.$toasted.success('Modification enregistrée !')
        this.$emit('saved')
        this.hideModal()
        this.cleanForm()
        this.loading = false
      }).catch((error) => {
        this.$toasted.error(`Mince ! Une erreur <br> ${error.response.data.message}`)
      })
    },
    cleanForm () {
      const now = new Date()
      this.form.done_workload_hour= 0
      this.form.done_workload=0
      this.form.internal_supplier= ''
      this.form.proceed_at= now.getFullYear()+'-'+(now.getMonth()+1)+'-'+now.getDate()
    }
  },
  mounted: function() {
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// EndKanbanBeModal.vue?6dd312ab